module.exports = __webpack_public_path__ + "static/media/Mnemonics.96cc4675.jpg";